module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc3-05-693b5ea0e90e49b1fd8e3d1816c5d535.png";